import { useEffect, useRef, useState } from "react"

export default function ChatInput({ onSend }) {
	const inputRef = useRef(null)
	const [isEmpty, setIsEmpty] = useState(true)

	const handleSend = () => {
		const text = inputRef.current.innerText.trim()
		if (text) {
			onSend(text)
			inputRef.current.innerText = ""
			setIsEmpty(true)
		}
	}

	// Handle Enter key
	const handleKeyDown = (e) => {
		if (e.key === "Enter" && !e.shiftKey) {
			e.preventDefault()
			handleSend()
		}
	}

	// Track empty state for placeholder
	const handleInput = () => {
		const text = inputRef.current.innerText.trim()
		setIsEmpty(text === "")
	}

	// Optional: focus on load
	useEffect(() => {
		inputRef.current?.focus()
	}, [])

	return (
		<div className=" flex flex-row gap-[0.5rem]">
			<div className="w-full border border-gray-300 rounded-xl px-2 bg-white shadow-sm relative">
				{isEmpty && (
					<div className="absolute left-3 top-2.5 text-gray-400 pointer-events-none select-none">
						Type a message
					</div>
				)}

				<div
					ref={inputRef}
					contentEditable
					onInput={handleInput}
					onKeyDown={handleKeyDown}
					style={{ wordBreak: "break-word" }}
					className="min-h-[40px] py-[0.6rem] max-h-40 overflow-y-auto outline-none whitespace-pre-wrap  px-[0.3rem] "
					role="textbox"
					aria-multiline="true"
				></div>
			</div>
			<div className="relative w-[45px]">
				<button
					onClick={handleSend}
					className="w-[40px] pl-[2px] h-[40px] flex rounded-[5rem] fill-white active:fill-[#f19b3e] absolute bottom-0 active:bg-white bg-[#f19b3e]"
				>
					<svg
						className="w-[18px] m-auto"
						viewBox="0 0 20 20"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							d="M1.631 0.121999C0.737502 -0.324501 -0.251498 0.527999 0.058002 1.4775L2.065 7.63C2.12177 7.80382 2.2251 7.95874 2.36377 8.07792C2.50244 8.19711 2.67113 8.27599 2.8515 8.306L10.7815 9.6275C11.199 9.6975 11.199 10.2975 10.7815 10.3675L2.852 11.689C2.67163 11.719 2.50294 11.7979 2.36427 11.9171C2.2256 12.0363 2.12227 12.1912 2.0655 12.365L0.058002 18.521C-0.251998 19.471 0.737502 20.3235 1.631 19.877L19.378 11.006C20.2075 10.591 20.2075 9.4075 19.378 8.993L1.631 0.121999Z"
							fill="inherit"
						/>
					</svg>
				</button>
			</div>
		</div>
	)
}
